module.exports = __webpack_public_path__ + "img/24.50a605b1.jpg";